/* eslint-disable @typescript-eslint/no-explicit-any */
import { get } from '../lib'
import saveAs from 'file-saver'

type _QueryVSDBDownload = {
  type: 'vsdb',
  id: number,
  scriptId: number
}
type _QueryDownloadDownload = {
  type: 'download',
  id: number
}

export interface ScriptResponseCollection {
  id: number
  name: string
}
export interface ScriptResponseDownloadFile {
  id: number
  name: string
  size: number
}
export interface ScriptResponse {
  id: number
  coremini16: boolean
  coremini32: boolean
  coreminiSize: number
  dateCreated: string
  downloadFile: ScriptResponseDownloadFile
  vsdbName: string
  vspyVersion: string
  collections: ScriptResponseCollection[]
}

type RequestType = _QueryDownloadDownload | _QueryVSDBDownload

type QuickviewResponseType =  {
  expires: string,
  token: string
} | string

//Note: for otheres, should pass through search filter
export const quickView = async (uploadFileVersionId: number): Promise<QuickviewResponseType> => {
  return get<QuickviewResponseType>({
    path: '/api/v1/quickView',
    query: {uploadFileVersionId},
    text: true
  })
}

export const getDownloadScript = (scriptId: number) => {
  return get<ScriptResponse>({
    path: `/api/v1/scripts/${scriptId}`
  })
}
